export default "__VITE_ASSET__YshanK1p__"